import { GLAMMATIC_ONBOARDING_LINK, ONBOARDING_LINK } from '../../../../modules/calendars/components/Calendly/Calendly.constants';
import { GLAMMATIC_BRAND_IDENTITY } from '../../PublishBanner.constants';
export function isGlammaticBrand(brandIdentity) {
  return brandIdentity === GLAMMATIC_BRAND_IDENTITY;
}
export function getStripeApiKey(brandIdentity) {
  if (isGlammaticBrand(brandIdentity)) {
    return process.env.STRIPE_GLAMMATIC_API_KEY || process.env.STORYBOOK_STRIPE_API_KEY;
  }
  return process.env.STRIPE_API_KEY || process.env.STORYBOOK_STRIPE_API_KEY;
}
export function getCalendlyOnboardingLink(brandIdentity) {
  if (isGlammaticBrand(brandIdentity)) {
    return GLAMMATIC_ONBOARDING_LINK;
  }
  return ONBOARDING_LINK;
}